
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/module/box/energy",
      function () {
        return require("private-next-pages/module/box/energy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/module/box/energy"])
      });
    }
  